export default __webpack_public_path__ + "static/media/jan2024-2.aa678c8d.jpg";